import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import httpService from "../../common/httpService";
import "./SpeakersComponent.scss";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";

const SpeakersComponent = () => {
  const [formData, setFormData] = useState({
    salutation: "",
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    is_online_approved: false,
    is_certificate_active: false,
    abstract: "",
    dinner_invitation: false,
    airport_pickup: false,
    free_trip: false,
    room_type: "",
    nights_covered: "",
    is_visa_payment_required: false,
    flight_ticket: "Economy Class",
    accommodation_room_type: "Single",
    accommodation_nights: 1,
    transportation: "One Way",
    visa_fees: "Not Covered",
    conference_dinner: "Not Included",
    conference_dinner_persons: 0,
    social_trip: "Not Included",
    registration_fee: "Not Covered",
    other: "",
  });

  const [conferences, setConferences] = useState([]);
  const [selectedConference, setSelectedConference] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchConferences = async () => {
      try {
        const response = await axios.get(
          "https://eventscons.com/eventbackendnew/api/conferences/all"
        );
        const data = response.data?.data;
        if (data && Array.isArray(data)) {
          setConferences(data);
        }
      } catch (error) {
        console.error("Error fetching conferences:", error);
      }
    };

    fetchConferences();
  }, []);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "conferenceSelect") {
      setSelectedConference(value);
      return;
    }

    const numericKeys = [
      "accommodation_nights",
      "conference_dinner_persons",
      "nights_covered",
    ];

    const nextValue =
      type === "checkbox"
        ? checked
        : numericKeys.includes(name)
        ? value === ""
          ? ""
          : Number(value)
        : value;

    setFormData((prev) => ({
      ...prev,
      [name]: nextValue,
    }));
  };

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const buildPayload = (data) => {
    const payload = {
      title: `${data.salutation}`.trim(),
      salutation: data.salutation,
      name: data.name.trim(),
      email: data.email.trim(),
      password: data.password,
      is_online_approved: !!data.is_online_approved,
      is_certificate_active: !!data.is_certificate_active,
      abstract: data.abstract?.trim() || null,
      dinner_invitation: !!data.dinner_invitation,
      airport_pickup: !!data.airport_pickup,
      free_trip: !!data.free_trip,
      room_type: data.accommodation_room_type,
      nights_covered: Number(data.accommodation_nights) || 0,
      is_visa_payment_required: !!data.is_visa_payment_required,
      flight_ticket: data.flight_ticket,
      accommodation_room_type: "Single",
      accommodation_nights: 1,
      transportation: data.transportation,
      visa_fees: data.visa_fees,
      conference_dinner: data.conference_dinner,
      social_trip: data.social_trip,
      registration_fee: data.registration_fee,
      other: data.other?.trim() || "",
    };

    if (data.conference_dinner === "Included") {
      payload.conference_dinner_persons =
        Number(data.conference_dinner_persons) || 0;
    }

    return payload;
  };

  const resetForm = () => {
    setFormData({
      salutation: "",
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      is_online_approved: false,
      is_certificate_active: false,
      abstract: "",
      dinner_invitation: false,
      airport_pickup: false,
      free_trip: false,
      room_type: "",
      nights_covered: "",
      is_visa_payment_required: false,
      flight_ticket: "Economy Class",
      accommodation_room_type: "Single",
      accommodation_nights: 1,
      transportation: "One Way",
      visa_fees: "Not Covered",
      conference_dinner: "Not Included",
      conference_dinner_persons: 0,
      social_trip: "Not Included",
      registration_fee: "Not Covered",
      other: "",
    });
    setSelectedConference("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedConference) {
      toast.error("Please select a conference.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    if (!validatePassword(formData.password)) {
      toast.error(
        "Password must be at least 8 characters long and include one uppercase, one lowercase, one number, and one special character."
      );
      return;
    }

    if (Number(formData.accommodation_nights) < 1) {
      toast.error("Accommodation nights must be at least 1.");
      return;
    }

    if (
      formData.conference_dinner === "Included" &&
      (!formData.conference_dinner_persons ||
        Number(formData.conference_dinner_persons) < 1)
    ) {
      toast.error("Please enter dinner persons (>=1).");
      return;
    }

    const payload = buildPayload(formData);
    console.log("Final Payload:", payload);

    const token =
      sessionStorage.getItem("adminToken") ||
      sessionStorage.getItem("token") ||
      localStorage.getItem("adminToken") ||
      localStorage.getItem("token");

    const num = Math.floor(Math.random() * (9999 - 99 + 1)) + 99;

    const url = `https://eventscons.com/eventbackendnew/api/admin/speakers/${num}/${selectedConference}`;

    setLoading(true);

    try {
      await httpService({
        method: "POST",
        url,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        withCredentials: true,
      });

      toast.success("Speaker registered successfully.");
      resetForm();
    } catch (error) {
      const status = error?.response?.status;
      const data = error?.response?.data;

      console.error("❌ API Error:", { status, data, message: error?.message });

      let errorMessage =
        (data && (data.error || data.message)) ||
        (data && data.errors && Object.values(data.errors)?.[0]?.[0]) ||
        error?.message ||
        "Something went wrong.";

      if (typeof data === "string" && data.trim()) {
        errorMessage = data;
      }

      if (status === 422) {
        const firstMsg =
          data?.message ||
          (data?.errors && Object.values(data.errors)?.[0]?.[0]) ||
          errorMessage ||
          "Validation error.";
        toast.error(firstMsg);
      } else if (status === 401 || status === 403) {
        toast.error("Unauthorized. Check admin token/login.");
      } else if (status === 404) {
        toast.error("Endpoint not found. Verify URL.");
      } else {
        toast.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <h6 className="headingaddspeakers">Add Speaker</h6>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="conferenceSelect">Select Conference *</label>
          <select
            id="conferenceSelect"
            name="conferenceSelect"
            value={selectedConference}
            onChange={handleChange}
            required
            style={{ width: "100%", padding: 8, marginTop: 5 }}
          >
            <option value="">-- Select Conference --</option>
            {conferences.map((conf) => (
              <option key={conf.id} value={conf.id}>
                {conf.title}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Salutation *</label>
          <select
            name="salutation"
            value={formData.salutation}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Salutation --</option>
            <option value="Mr">Mr.</option>
            <option value="Mrs">Mrs.</option>
            <option value="Ms">Ms.</option>
            <option value="Dr">Dr.</option>
            <option value="Prof">Prof.</option>
          </select>
        </div>

        <div className="form-group">
          <label>Speaker's Name *</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email Address *</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group password-group">
          <label>Assign a Password *</label>
          <div className="password-input">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span onClick={() => setShowPassword((p) => !p)}>
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
          <small style={{ color: "#777" }}>
            Password must contain uppercase, lowercase, number, special
            character and be at least 8 characters long.
          </small>
        </div>

        <div className="form-group password-group">
          <label>Confirm Password *</label>
          <div className="password-input">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            <span onClick={() => setShowConfirmPassword((p) => !p)}>
              {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>
        </div>

        <div className="form-group checkbox-row checkbox-custom">
          <label>
            <input
              type="checkbox"
              name="is_online_approved"
              checked={formData.is_online_approved}
              onChange={handleChange}
            />
            Online Approved
          </label>

          <label>
            <input
              type="checkbox"
              name="is_certificate_active"
              checked={formData.is_certificate_active}
              onChange={handleChange}
            />
            Certificate Active
          </label>
        </div>

        <div className="form-group">
          <label>Flight Ticket *</label>
          <select
            name="flight_ticket"
            value={formData.flight_ticket}
            onChange={handleChange}
          >
            <option value="Business Class">Business Class</option>
            <option value="Economy Class">Economy Class</option>
            <option value="None">None</option>
          </select>
        </div>

        <div className="form-group">
          <label>Room Type *</label>
          <select
            name="accommodation_room_type"
            value={formData.accommodation_room_type}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Room Type --</option>
            <option value="Single">Single</option>
            <option value="Double">Double</option>
            <option value="Triple">Triple</option>
            <option value="None">None</option>
          </select>
        </div>

        <div className="form-group">
          <label>Nights Covered *</label>
          <input
            type="number"
            name="accommodation_nights"
            value={formData.accommodation_nights}
            onChange={handleChange}
            min={1}
            required
          />
        </div>

        <div className="form-group">
          <label>Transportation *</label>
          <select
            name="transportation"
            value={formData.transportation}
            onChange={handleChange}
          >
            <option value="One Way">One Way</option>
            <option value="Two Ways">Two Ways</option>
            <option value="None">None</option>
          </select>
        </div>

        <div className="form-group">
          <label>Visa Fees *</label>
          <select
            name="visa_fees"
            value={formData.visa_fees}
            onChange={handleChange}
          >
            <option value="Covered">Covered</option>
            <option value="Not Covered">Not Covered</option>
          </select>
        </div>

        <div className="form-group">
          <label>Conference Dinner *</label>
          <select
            name="conference_dinner"
            value={formData.conference_dinner}
            onChange={handleChange}
          >
            <option value="Included">Included</option>
            <option value="Not Included">Not Included</option>
          </select>

          {formData.conference_dinner === "Included" && (
            <div className="form-group">
              <br />
              <label style={{ marginBottom: "0px" }}>No. of Persons</label>
              <input
                type="number"
                name="conference_dinner_persons"
                value={formData.conference_dinner_persons}
                onChange={handleChange}
                min={1}
                placeholder="No. of Persons"
                style={{ marginTop: 8 }}
                required
              />
            </div>
          )}
        </div>

        <div className="form-group">
          <label>Social Trip *</label>
          <select
            name="social_trip"
            value={formData.social_trip}
            onChange={handleChange}
          >
            <option value="Included">Included</option>
            <option value="Not Included">Not Included</option>
          </select>
        </div>

        <div className="form-group">
          <label>Registration Fee *</label>
          <select
            name="registration_fee"
            value={formData.registration_fee}
            onChange={handleChange}
          >
            <option value="Covered">Covered</option>
            <option value="Not Covered">Not Covered</option>
          </select>
        </div>

        <div className="form-group">
          <label>Other (Additional Covered Items)</label>
          <textarea
            style={{
              width: "100%",
              border: "1px solid #ccc",
              padding: "10px 12px",
              borderRadius: "6px",
              height: "100px",
            }}
            name="other"
            value={formData.other}
            onChange={handleChange}
            placeholder="e.g., Airport lounge access, early check-in"
          />
        </div>

        <button
          type="submit"
          className="submit-btn"
          style={{ width: "fit-content" }}
          disabled={loading}
        >
          {loading ? "Adding..." : "Add Speaker"}
        </button>
      </form>
    </div>
  );
};

export default SpeakersComponent;